import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { DictionaryClientDataRequestType } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';
import { DictionaryAPIService } from 'src/app/extensions/services/api/dictionary-api.service';
import { PartnerAPIService } from 'src/app/extensions/services/api/partner-api.service';
import { FilesHandler } from '../../utils/files-handler';
import { NgForm } from '@angular/forms';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { isNotEmpty } from 'src/app/extensions/utilities';
import { SIGNAL_ITEM_KEY } from 'src/app/extensions/constants/commonConstants';

@Component({
  selector: 'app-add-legal-information-request',
  templateUrl: './add-legal-information-request.component.html',
  styleUrls: ['./add-legal-information-request.component.scss'],
  standalone: false,
})
export class AddLegalInformationRequestComponent implements OnInit {
  clientDataRequestSaveModel: app.models.ClientDataRequestSaveModel = {
    legalRepresentatives: [{ firstName: undefined, lastName: undefined, phone: undefined }],
    documentsAttached: [],
  } as app.models.ClientDataRequestSaveModel;

  @ViewChild('form') public form: NgForm;

  private stateSignalItem: any;

  constructor(
    private _globalService: GlobalService,
    private _router: Router,
    private _dictionaryService: DictionaryAPIService,
    private _partnerService: PartnerAPIService,
    public _filesHandler: FilesHandler,
    public _activatedRoute: ActivatedRoute
  ) {
    this.stateSignalItem = this._globalService.getSignalItem(SIGNAL_ITEM_KEY.RQST_CLIENT_DATA);

    if (isNotEmpty(this.stateSignalItem)) {
      this.clientDataRequestSaveModel = this.stateSignalItem.data as app.models.ClientDataRequestSaveModel;
    }
  }

  ngOnInit(): void {
    if (!isNotEmpty(this.stateSignalItem)) {
      this.loadData();
    }
  }

  loadData() {
    let source = forkJoin([this._dictionaryService.getClientDataRequestTypes(), this._partnerService.getCompanyInfo()]);
    source.subscribe(([dictionaryClientDataRequestTypes, companyInfo]) => {
      if (companyInfo.data) {
        this.clientDataRequestSaveModel.partnerExternalEntityId = companyInfo.data.partnerExternalEntityId;
      }

      if (dictionaryClientDataRequestTypes.data) {
        let legalRepresentativeRequestType = dictionaryClientDataRequestTypes.data.find(
          x => x.code == DictionaryClientDataRequestType.LegalRepresentative
        );
        if (legalRepresentativeRequestType) {
          this.clientDataRequestSaveModel.dictionaryClientDataRequestTypeId = legalRepresentativeRequestType.id;
          this.clientDataRequestSaveModel.description = legalRepresentativeRequestType.description;
        }
      }
    });
  }

  removeLegalRepresenativeHandler(index: number) {
    this.clientDataRequestSaveModel.legalRepresentatives.splice(index, 1);
  }

  sendRequestCofirmationHandler() {
    if (this.form.invalid) {
      return;
    }

    this.stateSignalItem = {
      data: this.clientDataRequestSaveModel,
      routePath: this._activatedRoute.snapshot.routeConfig.path,
    };
    this._globalService.setSignalItem(SIGNAL_ITEM_KEY.RQST_CLIENT_DATA, this.stateSignalItem);
    this._router.navigate(['requests/client-data/new/request-preview']);
  }

  addPersonHandler() {
    this.clientDataRequestSaveModel.legalRepresentatives.push(
      {} as app.models.ClientDataRequestsLegalRepresentativeModel
    );
  }

  redirectListHandler = () => {
    this._router.navigate(['requests/client-data']);
  };

  redirectFieldSelectionHandler() {
    this._router.navigate(['requests/client-data/new']);
  }
}
